module.exports = __webpack_public_path__ + "img/pr-24.c132e6d0.png";